import { HttpServiceResponse } from '../../shared'
import { ApplicationDMQueueParams } from '../models/application/application-params.model'
import AbstractApplicationProvider from './application-abstract.provider'

export class ApplicationProvider extends AbstractApplicationProvider {
  public dmQueue<T = any>(params: ApplicationDMQueueParams): Promise<HttpServiceResponse<T>> {
    const url = this.customUrl('dm_queue_api')
    const query = this.query.stringify({
      action: 'viewappstatus',
      ...params,
    })

    return this.http.post(`${url}?${query}`)
  }
}
